import { createContext, useEffect, useState } from "react";
import { useToken } from "../../hooks/useToken";

export const AuthContext = createContext();


export const AuthContextProvider = ({ children }) => {

    const [
        token,
        {
            hasToken,
            saveToken,
            removeToken,
            getUserName,
            getUserEmail,
            getUserType,
            getUserCompanyId,
            getExp,
            getTypesOperations,
            getUserCompanyName,
        }
    ] = useToken();

    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userType, setUserType] = useState('');
    const [userCompanyId, setUserCompanyId] = useState('');
    const [userCompanyName, setUserCompanyName] = useState('');
    const [userOperations, setUserOperations] = useState('');
    const [expireIn, setExpireIn] = useState('');


    useEffect(() => {

        if (hasToken()) {
            setUserName(getUserName());
            setUserEmail(getUserEmail());
            setUserType(getUserType());
            setUserCompanyId(getUserCompanyId());
            setExpireIn(getExp());
            setUserOperations(getTypesOperations());
            setUserCompanyName(getUserCompanyName());
        }

    }, [token]);

    const isAdmin = () => {
        return userType;
    }

    const operations = () => {
        return userOperations;
    }

    const companyId = () => {
        return userCompanyId;
    }

    const companyName = () => {
        return userCompanyName;
    }

    const logout = () => {
        sessionStorage.removeItem('valueKanban');
        sessionStorage.removeItem('updateKanban');
        sessionStorage.removeItem('valueKanbanLabel');
        sessionStorage.removeItem('intervalUpatedCards');
        sessionStorage.removeItem('id_update_chart_farm');
        sessionStorage.removeItem('id_interval_sensorChart');
        sessionStorage.removeItem('valueTypeOperationCards');
        sessionStorage.removeItem('valueTypeOperationKanban');
        sessionStorage.removeItem('typeOperationUser');
        removeToken();
        window.location.href = '/login';
    }

    return (
        <AuthContext.Provider
            value={{
                userName: userName,
                userEmail: userEmail,
                userType: userType,
                userCompanyId: userCompanyId,
                companyName: companyName,
                operations: operations,
                companyId: companyId,
                expireIn: expireIn,
                isAdmin: isAdmin,
                logout: logout
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}